import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import LossesA2Table from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import lossesIcon from "../../../../../assets/new-product-detail-cats/sub-icons/prod-waste-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const LossesA2 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("LOSSES_TRANSPORT_A2") || "Losses in Transportation"}
        subDescription={t("LOSSES_TRANSPORT_A2_DESC") || "Materials lost during transportation."}
        isNormal={true}
        number={"32.3"}
        icon={lossesIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`losses-a2-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <LossesA2Table productId={productId} />
        </TableLoadingWrapper>
      )}

      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default LossesA2;

